/**
 * @file コンポーネント：フル動画ページノートボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ButtonNote = (props) => {
    /**
     * ノートを開く処理
     */
    const fnOnClickNote = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // ノートを開く
        props.setIsOpenNote(true);
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnClickNote={fnOnClickNote} />;
};
